<template>
    <div class="tools-rank-box tools-admission-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>录取院校测试</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row type="flex" justify="space-between" :gutter="16">
            <el-col :span="16">
                <el-row class="tools-box-content">
                    <h5>录取院校测试</h5>
                    <div class="tools-score-search">
                        <div class="type-list">
                            <div class="title-box">科目类型：</div>
                            <div class="type-name">
                                <a v-for="(item,index) in typeList" :key="index" :class="activeTag == item.local_type?'active-tag':''" @click="activeTagHandler(item.local_type)">{{item.name}}</a>
                            </div>
                        </div>
                        <div class="type-list">
                            <div class="title-box">招生批次：</div>
                            <div class="type-name">
                                <a v-for="(item,index) in optionList" :key="index" :class="activeTag1 == index?'active-tag':''" @click="activeTagHandler1(index)">{{item.name}}</a>
                            </div>
                        </div>
                        <div class="type-list type-list-diff">
                            <div class="title-box">高考分数/预估分数：</div>
                            <div class="type-score">分数范围：0分到750分</div>
                        </div>
                        <div class="search-img header-search">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="score-form" @submit.native.prevent>
                                <el-form-item prop="score">
                                    <el-input placeholder="请输入高考分数/预估分数" v-model="ruleForm.score" @keyup.enter.native="searchAdmissionListHandler()">
                                    </el-input>
                                    <!-- <div class="el-form-item__error" v-if="showErrorStatus">
                                        超出分数范围
                                    </div> -->
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="searchAdmissionListHandler" class="tools-btn">开始查询</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-row class="tools-rank-list">
                        <el-table :data="scoreLineList" stripe style="width: 100%" border class="tools-table-box" :key="Math.random()">
                            <el-table-column label="录取概率" prop="percent" width="95">
                                <template slot-scope="scope">
                                    {{ scope.row.percent + '%' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="院校名称" prop="scl_name" width="170">
                            </el-table-column>
                            <el-table-column label="批次" prop="scl_name" width="130">
                                <template slot-scope="scope">
                                    {{ batchObj[scope.row.local_batch_id] }}
                                </template>
                            </el-table-column>
                            <el-table-column label="招生计划" width="100">
                                 <template slot-scope="scope">
                                    <div class="tools-admission-btn" @click="schoolDetailHandler(scope.row.scl_id)">查看</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="近三年录取分数" align="center">
                                <el-table-column v-for="(item,key,index) in yearList"
                                  :key="key"
                                  min-width="80">
                                    <template #header>
                                        {{ item }}
                                    </template>
                                    <template slot-scope="scope">
                                        {{ scope.row['score_min' + (index + 1)]?scope.row['score_min' + (index + 1)]:'-' }}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            layout="prev, pager, next, jumper"
                            :total="totalData" :page-size="10" @current-change="getAdmissionListHandler" :current-page.sync='currentPage' v-if="totalData > 0">
                        </el-pagination>
                    </el-row>
                </el-row>
            </el-col>
            <el-col :span="8" class="tools-box-news">
                <SchoolRank></SchoolRank>
                <News></News>
            </el-col>
        </el-row>
    </div>
</template>
 
<script>
import { getAdmissionList } from '@/api/tools'
import { mapState } from 'vuex'
export default {
    data() {
        const validateScore = (rule, value, callback) => {
            if (value.length === 0) {
            callback(new Error("请输入分数"));
            } else {
                if ((/(^[1-9]\d*$)/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的分数"));
                }
            }
        }; 
        return {
            typeList: [],
            activeTag: 0,
            activeTag1: '',
            toolsList: [],
            ruleForm: {
                score: this.$store.state.user.gkInforObj.score
            },
            rules: {
                score: [
                    { required: true, trigger: 'blur', validator: validateScore },
                ],
            },
            scoreLineList: [],
            totalData: 0,
            currentPage: 1,
            yearList: {},
            batchList: [],
            batchObj: {
                '6':'本科提前批',
                '7':'本科一批',
                '8':'本科二批',
                '10':'专科批',
                '11':'专科提前批',
				'14': '本科批'
            },
            optionList: {},
        };
    },
    computed: {
        ...mapState({
            provinceCode: state => state.user.provinceCode,
        })
    },
    watch: {
        provinceCode (newVal) {
            if(newVal && this.ruleForm.score) {
                this.getAdmissionListHandler();
            }
        },
    },
    mounted() {
        setTimeout(()=>{
            this.typeList = JSON.parse(sessionStorage.getItem('newSubject'))
            this.batchList = JSON.parse(sessionStorage.getItem('newBatch'))
            this.activeTag = this.typeList[0].local_type
            this.batchList.map(item => {
                this.optionList[`batch_${item.local_batch_id}`] = item
            })
            this.activeTag1 = `batch_${this.batchList[0].local_batch_id}`
            this.$forceUpdate();
            if(this.ruleForm.score) {
                this.getAdmissionListHandler();
            }
        }, 1000)
    },
    methods: {
        activeTagHandler(index) {
            this.activeTag = index;
            this.currentPage = 1;
            this.scoreLineList = [];
            this.yearList = {};
            this.searchAdmissionListHandler()
        },
        activeTagHandler1(index) {
            this.activeTag1 = index;
            this.currentPage = 1;
            this.scoreLineList = [];
            this.yearList = {};
            this.searchAdmissionListHandler()
        },
        searchAdmissionListHandler() {
            this.$refs.ruleForm.validate((valid) => {
                if(valid) { 
                    this.getAdmissionListHandler();
                }
            })
        },
        getAdmissionListHandler() {
            let local_type_id = this.activeTag;
            let area = localStorage.getItem("area");
            getAdmissionList(local_type_id, this.ruleForm.score, this.activeTag1.split('_')[1], area, this.currentPage).then(res => {
                if(res.data) {
                    this.scoreLineList = res.data.data;
                    res.data.data.map(item => {
                        for (const key in item) {
                            if (item.hasOwnProperty(key)) {
                                if(key === 'year1' || key === 'year2' || key === 'year3') {
                                    if((!this.yearList.hasOwnProperty(key)) && item[key]) {
                                        this.yearList[key] = item[key]
                                    }
                                }
                            }
                        }
                    })
                    this.totalData = res.data.count;
                }     
            })
        },
        schoolDetailHandler(scl_id) {
            this.$router.push({
                path:'/schoolDetail',
                query: {
                    scl_id: scl_id
                }
            })
        }
    },
};
</script>
 
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.tools-rank-box {
    @include gwidth;
    .tools-box-content {
        padding: 24px;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10); 
        margin-top: 24px;
        min-height: 350px;
        h5 {
            border-left: 2px solid $common-color;
            border-radius: 1px;
            font-size: 22px;
            font-weight: 600;
            color: #2c2e33;
            padding-left: 8px;
            text-align: left;
            padding-bottom: 0px;
            margin-bottom: 24px;
            margin-top: 0;
        }
    }
    .tools-score-search {
        background: url('../../assets/images/tools-search-bg.png') no-repeat;
        background-size: 100% 100%;
        height: 233px;
        padding: 24px;
        box-sizing: border-box;
        margin-top: 20px;
    }
    .type-list {
        @include gflex;
        font-size: 0;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 5px;
        .title-box {
            min-width: 78px;
            padding: 3px 6px 3px 0;
            font-size: 14px;
            text-align: left;
            color: #ffffff;
        }
        a {
            display: inline-block;
            font-size: 14px;
            color: #5e6166;
            color: #ffffff;
            text-align: center;
            margin-bottom: 12px;
            padding: 3px 6px;
            cursor: pointer;
        }
        a:not(:nth-child(13n)) {
            margin-right: 12px;
        }
        // a:hover {
        //     color: $common-color;
        // }
        .active-tag {
            color: $common-color!important;
            background: #ffffff;
            border-radius: 4px;
        }
        .type-name {
            @include gflex;
            width: calc(100% - 4px);
            justify-content: flex-start;
            flex-wrap: wrap;
        }
        .type-score {
            color: #ffd160;
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            padding: 3px 6px 3px 0;
        }
    }
    .search-img {
        margin-top: 10px;
    }
    .tools-btn {
        width: 136px;
        height: 52px;
        border: none!important;
        background: linear-gradient(90deg,#ffa94a, #ff913c);
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        border: none;
        margin-left: 14px;
        position: relative;
        top: 0px;
    }
    .type-list-diff {
        justify-content: left;
        line-height: 20px;
    }
    .tools-rank-list {
        .tools-rank-item {
            height: 80px;
            background: #ffffff;
            border: 1px solid #ebedf0;
            border-radius: 4px;
            text-align: center;
            line-height: 40px;
            .tools-rank-item-title {
                height: 40px;
                background: #f5f7fa;
            }
            .tools-rank-item-score {
                font-weight: 600;
                font-size: 18px;
                color: $common-color;
            }
        }
    }
}
.tools-canvas {
    position: relative;
    left: -90px;
    top: -45px;
    width:910px;
    height:450px;
}
.tools-canvas-title {
    font-size: 14px;
    color: #5e6166;
    margin-top: 32px;
}
.tools-box-news {
    margin-top: 24px;
}
.no-data-box {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
        margin-left: -14px;
    }
}
</style>